import Mlp from 'umg-ember-backend/components/record-detail/for/mlp';

<template><Mlp @model={{@model}} /></template>
